import { ShopOutlined, UserOutlined, WarningOutlined } from '@ant-design/icons';

import './styles/BillingBlockedStub.desktop.scss';

// Заглушка для обычного сотрудника (не админ/не суперадмин), когда филиал
// заблокирован за неоплату. Оплатить тариф может только администратор,
// поэтому сотруднику показываем информационный экран и ограничиваем доступ
// к остальным разделам (сменить филиал / профиль / помощь / выход остаются).
//
// Визуальный язык — как в новых модулях (Лиды / Реестр / Воронки / Карточка):
// компактная белая панель, тонкий бордер вместо тени, мелкая типографика,
// цвет только как семантика состояния. См. docs/memory/shared/lead-card-ui-style.md.
const ROOT = 'bc-billing-blocked-stub';

export const BillingBlockedStub = () => (
  <div className={ROOT}>
    <div className={`${ROOT}__panel`}>
      <span className={`${ROOT}__icon`}>
        <WarningOutlined />
      </span>

      <div className={`${ROOT}__text`}>
        <h2 className={`${ROOT}__title`}>Тариф не оплачен</h2>
        <p className={`${ROOT}__description`}>
          Оплата тарифа по текущему филиалу просрочена, доступ к разделам
          временно ограничен.
        </p>
      </div>

      <ul className={`${ROOT}__hints`}>
        <li className={`${ROOT}__hint`}>
          <UserOutlined className={`${ROOT}__hint-icon`} />
          <span>Оплатить тариф может администратор организации</span>
        </li>
        <li className={`${ROOT}__hint`}>
          <ShopOutlined className={`${ROOT}__hint-icon`} />
          <span>Или смените филиал в меню слева</span>
        </li>
      </ul>
    </div>
  </div>
);
